import React from "react";
import { connect } from "react-redux";
import appConfig from "../../config/appConfig";
import { verifyPermission } from "../../helpers/permission";
import { ERROR_401 } from "../../config/errorPage";
import ImportFileForm from "../components/ImportFileForm";
import { useTranslation } from "react-i18next";

const FaqImportPage = (props) => {
  //usage of useTranslation i18n
  const { t, ready } = useTranslation();

  document.title =
    "Satis client - " + ready ? t("Importation FAQ") : "";
  if (!verifyPermission(props.userPermissions, "store-faq"))
    window.location.href = ERROR_401;

  return ready ? (
    verifyPermission(props.userPermissions, "store-faq") ? (
      <ImportFileForm
        submitEndpoint={`${appConfig.apiDomaine}/import-faqs`}
        pageTitleLink="/settings/faqs/add"
        pageTitle={t("FAQ")}
        panelTitle={t(
          "Importation de FAQ au format excel"
        )}
      />
    ) : null
  ) : null;
};

const mapStateToProps = (state) => {
  return {
    userPermissions: state.user.user.permissions,
  };
};

export default connect(mapStateToProps)(FaqImportPage);
